import {
  ClientUserUpdatePatch,
  reqDeleteAccount,
  reqSyncClientUser,
  reqUpdateClientUser,
  reqUpdateClientUsername,
  SyncClientUser,
  UpdateClientUser,
  UpdateClientUsername,
} from '@weblite/ts-action/client-user'
import { httpRequest } from '$setup/http'
import { request, requestNow } from '$setup/ws'
import { clientUserStorage } from './storage'
import * as sync from './offline-sync'
import afterSignOut from '../../hooks/after/signout'

export const getClientUser = clientUserStorage.get

export async function deleteAccount(): Promise<boolean> {
  const res = await httpRequest(reqDeleteAccount({}))
  if (res.error) return false
  afterSignOut()
  return true
}

export async function updateClientUser(updatedFields: ClientUserUpdatePatch) {
  const unsetSync = await sync.set(updatedFields)
  await clientUserStorage.set(updatedFields)
  const res = await request<UpdateClientUser>(
    reqUpdateClientUser({ updatedFields }),
  )
  await unsetSync()
  return res
}

export async function updateClientUsername(username: string | null) {
  const res = await request<UpdateClientUsername>(
    reqUpdateClientUsername({ username }),
  )
  // TODO: error code will change later
  if ('error' in res) {
    return res.error?.code === 'repetitive-username'
      ? 'NOT_AVAILABLE'
      : 'INVALID'
  }
  await clientUserStorage.set({ username })

  return 'AVAILABLE'
}

export async function syncClientUser(): Promise<void> {
  const { item, del, release } = await sync.get()
  try {
    const res = await requestNow<SyncClientUser>(
      reqSyncClientUser({ clientUser: item }),
    )
    await clientUserStorage.set(res.payload)
    await del()
  } finally {
    release()
  }
}

export function getClientUserId() {
  return getClientUser()?.id
}
